import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, submitted: false, error: null });

    try {
      // Mailgun API configuration
      // Replace these with your actual Mailgun credentials
      const MAILGUN_DOMAIN = 'mail.recordnews.co.za';
      const MAILGUN_API_KEY = '4790b0695c372a50c38cb0065eb4f5b0-88b1ca9f-4cd5025a';
      const TO_EMAIL = process.env.CONTACT_EMAIL;

      const mailgunData = new FormData();
      mailgunData.append('from', `${formData.name} <${formData.email}>`);
      mailgunData.append('to', 'fulela.makasi@gmail.com');
      mailgunData.append('subject', `New Contact Form Submission from ${formData.name}`);
      mailgunData.append('text', `
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Company: ${formData.company}
Service Interest: ${formData.service}

Message:
${formData.message}
      `);
      mailgunData.append('html', `
<h2>New Contact Form Submission</h2>
<p><strong>Name:</strong> ${formData.name}</p>
<p><strong>Email:</strong> ${formData.email}</p>
<p><strong>Phone:</strong> ${formData.phone}</p>
<p><strong>Company:</strong> ${formData.company}</p>
<p><strong>Service Interest:</strong> ${formData.service}</p>
<h3>Message:</h3>
<p>${formData.message.replace(/\n/g, '<br>')}</p>
      `);

      const response = await axios.post(
        `https://api.mailgun.net/v3/${MAILGUN_DOMAIN}/messages`,
        mailgunData,
        {
          auth: {
            username: 'api',
            password: MAILGUN_API_KEY
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (response.status === 200) {
        setFormStatus({ submitting: false, submitted: true, error: null });
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: ''
        });

        // Reset success message after 5 seconds
        setTimeout(() => {
          setFormStatus({ submitting: false, submitted: false, error: null });
        }, 5000);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setFormStatus({
        submitting: false,
        submitted: false,
        error: 'Failed to send message. Please try again or contact us directly.'
      });
    }
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1 className="fade-in">Get In Touch</h1>
          <p className="contact-hero-subtitle fade-in">
            Let's discuss how we can help with your technology needs
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section section-light">
        <div className="container">
          <div className="contact-content">
            {/* Contact Information */}
            <div className="contact-info">
              <h2>Contact Information</h2>
              <p className="contact-intro">
                Have a project in mind? We'd love to hear from you. Send us a message 
                and we'll respond as soon as possible.
              </p>

              <div className="info-items">
                <div className="info-item">
                  <div className="info-icon">📧</div>
                  <div>
                    <h4>Email</h4>
                    <p>info@mndinitech.co.za</p>
                    <p>support@mndinitech.co.za</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div>
                    <h4>Phone</h4>
                    <p>+27 (0) 78 724 1301</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div>
                    <h4>Address</h4>
                    <p>152 Van Dalen Rd</p>
                    <p>Willowbrook, Roodepoort</p>
                    <p>Gauteng, South Africa</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">🕒</div>
                  <div>
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
                    <p>Saturday: 9:00 AM - 1:00 PM</p>
                    <p>Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <h4>Connect With Us</h4>
                <div className="social-buttons">
                  <a href="#" className="social-btn">LinkedIn</a>
                  <a href="#" className="social-btn">Twitter</a>
                  <a href="#" className="social-btn">GitHub</a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <form className="contact-form" onSubmit={handleSubmit}>
                <h3>Send Us a Message</h3>

                {formStatus.submitted && (
                  <div className="alert alert-success">
                    Thank you for your message! We'll get back to you soon.
                  </div>
                )}

                {formStatus.error && (
                  <div className="alert alert-error">
                    {formStatus.error}
                  </div>
                )}

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+27 82 765 4321"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="company">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your Company"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service">Service Interest</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Select a service</option>
                    <option value="software-development">Software Development</option>
                    <option value="consultancy">Consultancy Services</option>
                    <option value="it-procurement">IT Equipment Procurement</option>
                    <option value="legacy-migration">Legacy System Migration</option>
                    <option value="business-analysis">Business Analysis</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us about your project..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-full"
                  disabled={formStatus.submitting}
                >
                  {formStatus.submitting ? 'Sending...' : 'Send Message'}
                </button>

                <p className="form-note">
                  * Required fields. We respect your privacy and will never share your information.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
